import { useEffect, useState } from "react";
import moment from "moment";
import SessionModel from "../../api/models/SessionModel";
import { GetCurrentWindowSize } from "../../hooks/useWindowSize";
import JitsiMeetingWindow from "../Jitsi/JitsiMeetingWindow";
import RoomContainer from "../RoomContainer/RoomContainer";
import SessionsMenu from "./SessionsMenu";
import IJitsiMeetExternalApi from "@jitsi/react-sdk/lib/types/IJitsiMeetExternalApi";
import useTimeout from "../../hooks/useTimeout";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { UserType } from "../../context/AuthContext";

import { createBrowserHistory } from "history";
import BBBMeetingWindow from "../BigBlueButton/BBBMeetingWindow";

type UserSessionRoomProps = {
  showTrailingContent: boolean;
  session: SessionModel;
  navigationItems: any[];
  viewsSize: any[];
  jitsiApiRef: React.MutableRefObject<IJitsiMeetExternalApi | null>;
  views: any[];
  trailingContentIndex: number;
  trailingMaxWidth: "360px" | "640px";
  userType: UserType | undefined | null;
};

function UserSessionRoom({
  showTrailingContent,
  session,
  userType,
  navigationItems,
  jitsiApiRef,
  viewsSize,
  views,
  trailingContentIndex,
  trailingMaxWidth,
}: UserSessionRoomProps) {
  const { t } = useTranslation("", {
    keyPrefix: "page.tutor.dashboard.room",
  });
  const [seed, setSeed] = useState<number>(10);

  useEffect(() => {
    const handleTabClose = (event: any) => {
      event.preventDefault();
      // to refresh component only
      setSeed(Math.random());
      return (event.returnValue = t("confirmCloseTab"));
    };
    // The beforeunload event is triggered when the window or the tab is about to be unloaded.
    window.addEventListener("beforeunload", handleTabClose);
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const now = moment();
  const alertReminder =
    (15 + session?.start_time!.diff(now, "minutes")) * 60 * 1000;
  const RunAlertHandler = () => {
    useTimeout(() => {
      toast.success(t("endSessionAfter"));
    }, alertReminder);
  };
  if (
    userType !== UserType.Student &&
    session?.student?.object_type === "Candidate"
  ) {
    RunAlertHandler();
  }

  const history = createBrowserHistory();
  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.go(1);
      }
    };
  }, [history]);
  return (
    <div className="relative overflow-x-hidden w-screen min-h-screen bg-[#040404]">
      {!showTrailingContent && !!session && (
        <div className="hidden sm:flex  sm:absolute rtl:left-0 ltr:right-0  top-0 h-screen justify-center items-center it z-50 ">
          <div className="p-2 h-fit">
            <SessionsMenu
              menu={navigationItems}
              sponsorshipBranding={session.sponsorshipBranding}
            />
          </div>
        </div>
      )}
      {!showTrailingContent && !!session && (
        <div className=" h-[72px] flex flex-col justify-center items-center sm:hidden mx-auto py-2">
          <SessionsMenu
            menu={navigationItems}
            sponsorshipBranding={session.sponsorshipBranding}
          />
        </div>
      )}
      <RoomContainer
        meetingWindow={
          <MeetingWindow
            seed={seed}
            session={session}
            jitsiApiRef={jitsiApiRef}
          />
        }
        trailingContent={views[trailingContentIndex]}
        windowSize={
          GetCurrentWindowSize() === "sm"
            ? viewsSize[trailingContentIndex].sm
            : viewsSize[trailingContentIndex].md
        }
        showTrailingContent={showTrailingContent}
        trailingMaxWidth={trailingMaxWidth}
      />
    </div>
  );
}

type MeetingWindowProps = {
  session: SessionModel;
  jitsiApiRef?: React.MutableRefObject<IJitsiMeetExternalApi | null>;
  seed: number;
};

function MeetingWindow(props: MeetingWindowProps): JSX.Element {
  const { session, jitsiApiRef, seed } = props;

  if (session.serviceProvider === "jitsi") {
    return (
      <JitsiMeetingWindow
        session={!!session ? session : new SessionModel({})}
        jitsiApiRef={jitsiApiRef}
        key={seed}
      />
    );
  }
  return <BBBMeetingWindow meetingUrl={session.meetingUrl} />
}
export default UserSessionRoom;
